import RegistryEntryCard, { type RegistryEntryConfig } from '../../../components/registry/RegistryEntryCard';
import { HEPATO_PHASES, computePhaseStatuses } from './phases';

const config: RegistryEntryConfig = {
  program: 'HEPATO',
  title: 'Fișă de registru hepato',
  buttonLabel: 'Deschide spațiul de lucru hepato',
  buttonTestId: 'open-hepato-workspace',
  routeSegment: 'hepato',
  phases: HEPATO_PHASES,
  computeStatuses: computePhaseStatuses,
  flowDescription: 'Datele importate din documente sunt organizate pe cele 4 faze ale fluxului medical:',
};

/**
 * Cartela compactă din fișa pacientului pentru registrul hepato importat:
 * sumar pe faze + link spre spațiul de lucru (/patients/:id/hepato/faza-1).
 */
export default function HepatoRegistryEntry({ patientId }: { patientId: string }) {
  return <RegistryEntryCard config={config} patientId={patientId} />;
}
